import React from "react";
import { IconContext } from 'react-icons/lib';

export default function ResizeRecolorEmail({ children }) {
    return (
        <>
            <IconContext.Provider value={{ color: "black", size: "5em", style: { verticalAlign: 'middle' }}}>
                {children}
            </IconContext.Provider>
        </>
    );
}